import { render } from "./TakePhotoView.vue?vue&type=template&id=9c30f974"
import script from "./TakePhotoView.vue?vue&type=script&lang=js"
export * from "./TakePhotoView.vue?vue&type=script&lang=js"

import "./TakePhotoView.vue?vue&type=style&index=0&id=9c30f974&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__